// services/rbacApi.js
import { createApiClient } from './httpClient';

const API_BASE_URL = process.env.REACT_APP_REST_BASE_URL || 'http://localhost:8000/api';

const rbacApi = createApiClient({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add response interceptor to handle errors globally if needed
rbacApi.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

export default rbacApi;
